import React from "react";
import '../../styles/components/settings/settings-menu.scss';
import SettingsMenuItem from "./SettingsMenuItem";
import {settingsPagePaths} from "../../config/config";
import {useAppSelector} from "../../redux/hooks";
import {settingsPageStore} from "../../redux/settingsPage/settingsPageStore";
import deviceInfo from "../../services/deviceInfo/deviceInfo";

export default function SettingsMenu() {
  const selectedSection = useAppSelector(settingsPageStore.getSelectedSection);
  const aboutLinkLabel = deviceInfo.getIsMobile() ? "About" : "About Playground Sessions";

  return (
    <div className="settings-menu">
      <header>Settings</header>
      <div className="settings-menu-items">
        <SettingsMenuItem>
          <a className={selectedSection === "keyboardAndVolumes" ? "selected": ""} href={`#${settingsPagePaths.keyboardAndVolumes}`}>
            Keyboard & Volumes
          </a>
        </SettingsMenuItem>
        <SettingsMenuItem>
          <a className={selectedSection === "myAccount" ? "selected": ""} href={`#${settingsPagePaths.myAccount}`}>
            Account
          </a>
        </SettingsMenuItem>
        <SettingsMenuItem>
          <a className={selectedSection === "privacy" ? "selected": ""} href={`#${settingsPagePaths.privacy}`}>
            Privacy
          </a>
        </SettingsMenuItem>
        <SettingsMenuItem>
          <a className={selectedSection === "about" ? "selected": ""} href={`#${settingsPagePaths.about}`}>
            {aboutLinkLabel}
          </a>
        </SettingsMenuItem>
      </div>
    </div>
  );
}